<template>
    <div class="wizardCreateAuth">
        <div class="steps mb-6">
            <div class="steps__step" :class="getModalAuth == 2 ? 'steps__step--current' : ''" data-step="0"
                @click.prevent="setModalAuth(2)">
                <div class="steps__step-number">1</div>
                <div class="steps__step-name">{{ $t('Modals.create_account') }}</div>
            </div>
            <div class="steps__connector"></div>
            <div class="steps__step" :class="getModalAuth == 3 ? 'steps__step--current' : ''" data-step="1"
                @click.prevent="setModalAuth(3)">
                <div class="steps__step-number">2</div>
                <div class="steps__step-name">{{ $t('Modals.activate_account') }}</div>
            </div>
            <div class="steps__connector"></div>
            <div class="steps__step" data-step="2" @click.prevent="setModalAuth(1)">
                <div class="steps__step-number">3</div>
                <div class="steps__step-name">{{ $t('Modals.log_in') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
    mixins: [],
    data: () => ({}),
    watch: {},
    computed: {
        // Acceder al state de 'auth' module
        ...mapState('auth', ['modalAuth']),

        // Usar getters de 'auth' module
        ...mapGetters('auth', ['getModalAuth']),
    },
    methods: {
        // Usar acciones de 'auth' module
        ...mapActions('auth', ['setModalAuth']),
    },
    mounted() { },
};
</script>

<style></style>
